import { BottomSheetMobileLayout } from "@l2r-front/l2r-ui"

import { FILTERS } from "../../constants/filters"
import { Map } from "../../containers/Map"
import { MobileDocumentFilterButton } from "../../containers/MobileDocumentFilterButton"

import { DocumentContentRouterMobile } from "../DocumentContentRouter"
import { DocumentMapRouterMobile } from "../DocumentMapRouter"

export function DocumentMobileRouter() {

    return <BottomSheetMobileLayout
        BottomSheetRouter={DocumentContentRouterMobile}
        MapComponent={Map}
        MapRouter={DocumentMapRouterMobile}
        mapProps={{ bottomRightElements: [<MobileDocumentFilterButton enabledFilters={FILTERS} key="document-filter-button" />] }}
    />
}
